(() => {
    "use strict"

    if (document.getElementById('carousel')) {
        new Splide('#carousel', {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            pagination: false,
            arrows: true,
            gap: 'clamp(1rem, 3.5vw, 3rem)',
        })
        .mount()
    }

    // GENIUS!
    function carousel(target = 'carousel') {
        // ------------------------------------------------------------------------
        // Get a reference to the UI elements
        // ------------------------------------------------------------------------
        
        const carousel = document.querySelector(`.${target}`)
        const track = carousel.querySelector(`.${target}__track`)
        const arrows = carousel.querySelector(`.${target}__arrows`)
        const prevArrow = carousel.querySelector(`.${target}__arrow--prev`)
        const nextArrow = carousel.querySelector(`.${target}__arrow--next`)

        // ------------------------------------------------------------------------
        // Check if the UI elements are defined
        // ------------------------------------------------------------------------
        
        if (!carousel) {
            console.error(`Did you specify the ${target} element?`)
            return
        }
        if (!track) {
            console.error(`Did you specify the ${target} track element?`)
            return
        }
        if (!arrows) {
            console.error(`Did you specify the ${target} arrows element?`)
            return
        }
        if (!prevArrow) {
            console.error(`Did you specify the ${target} prev arrow element?`)
            return
        }
        if (!nextArrow) {
            console.error(`Did you specify the ${target} next arrow element?`)
            return
        }

        // ------------------------------------------------------------------------
        // Handle carousel functionality
        // ------------------------------------------------------------------------

        const toggleButtons = () => {
            const scrollLeft = track.scrollLeft
            // Use a 1px threshold to account for sub-pixel rendering issues
            const maxScroll = track.scrollWidth - track.clientWidth

            // Handle Previous Arrow
            if (scrollLeft <= 0) {
                prevArrow.disabled = true
                prevArrow.classList.add('is-disabled')
            } else {
                prevArrow.disabled = false
                prevArrow.classList.remove('is-disabled')
            }

            // Handle Next Arrow
            if (scrollLeft >= maxScroll - 1) {
                nextArrow.disabled = true
                nextArrow.classList.add('is-disabled')
            } else {
                nextArrow.disabled = false
                nextArrow.classList.remove('is-disabled')
            }
        }
        
        const scroll = (dir = 1|-1) => {
            track.scrollBy({
                left: dir * track.clientWidth,
                behavior: 'smooth'
            })
        }

        // ------------------------------------------------------------------------
        // Set up event listeners
        // ------------------------------------------------------------------------

        // Listen for arrow clicks
        prevArrow.addEventListener('click', () => scroll(-1))
        nextArrow.addEventListener('click', () => scroll(1))

        // Update button state on scroll
        track.addEventListener('scroll', toggleButtons)

        // Update button state on resize
        window.addEventListener('resize', toggleButtons)

        // Initial check on load
        toggleButtons()
    }

    if (document.querySelector('.carousel')) carousel()
    if (document.querySelector('.page-portals')) carousel('page-portals')
    if (document.querySelector('.blogs')) carousel('blogs')

    function initToggles() {
        const toggles = document.querySelectorAll('[data-toggle]')

        toggles.forEach(toggle => {
            toggle.addEventListener('click', evt => {
                handleToggle(evt.target)
            });

            // toggle.addEventListener('focusout', evt => {
            //     handleToggle(evt.target, true)
            // })
        })
    }

    function handleToggle(toggle, hideOnly = false) {
        const targetId = toggle.getAttribute('data-toggle')
        const targetEl = document.querySelector(`[data-element="${targetId}"]`)

        if (!targetEl) {
            console.warn(`Target [data-element="${targetId}"] not found.`)
            return
        }

        // Determine the new state
        // If hideOnly is true, we are explicitly forcing 'false' (closed)
        // If hideOnly is false, we flip the current state
        const newState = hideOnly ? false : !toggle.classList.contains('is-active')

        // Apply classes based on state
        toggle.classList.toggle('is-active', newState)
        targetEl.classList.toggle('is-active', newState)

        // Handle height transitions
        const wrapper = targetEl.querySelector('[data-match-height]')
        if (wrapper) {
            if (newState) {
                wrapper.style.height = `${wrapper.scrollHeight}px`
            } else {
                wrapper.style.height = '0px'
            }
        }
    }

    initToggles()
})()